var Et = Object.defineProperty, bt = Object.defineProperties;
var St = Object.getOwnPropertyDescriptors;
var Oe = Object.getOwnPropertySymbols;
var Rt = Object.prototype.hasOwnProperty, At = Object.prototype.propertyIsEnumerable;
var $ = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e), Tt = (e) => {
  throw TypeError(e);
};
var xe = (e, t, n) => t in e ? Et(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, j = (e, t) => {
  for (var n in t || (t = {}))
    Rt.call(t, n) && xe(e, n, t[n]);
  if (Oe)
    for (var n of Oe(t))
      At.call(t, n) && xe(e, n, t[n]);
  return e;
}, _e = (e, t) => bt(e, St(t));
var E = (e, t, n) => new Promise((r, s) => {
  var o = (d) => {
    try {
      c(n.next(d));
    } catch (l) {
      s(l);
    }
  }, i = (d) => {
    try {
      c(n.throw(d));
    } catch (l) {
      s(l);
    }
  }, c = (d) => d.done ? r(d.value) : Promise.resolve(d.value).then(o, i);
  c((n = n.apply(e, t)).next());
}), D = function(e, t) {
  this[0] = e, this[1] = t;
}, ae = (e, t, n) => {
  var r = (i, c, d, l) => {
    try {
      var u = n[i](c), f = (c = u.value) instanceof D, w = u.done;
      Promise.resolve(f ? c[0] : c).then((g) => f ? r(i === "return" ? i : "next", c[1] ? { done: g.done, value: g.value } : g, d, l) : d({ value: g, done: w })).catch((g) => r("throw", g, d, l));
    } catch (g) {
      l(g);
    }
  }, s = (i) => o[i] = (c) => new Promise((d, l) => r(i, c, d, l)), o = {};
  return n = n.apply(e, t), o[$("asyncIterator")] = () => o, s("next"), s("throw"), s("return"), o;
}, ce = (e) => {
  var t = e[$("asyncIterator")], n = !1, r, s = {};
  return t == null ? (t = e[$("iterator")](), r = (o) => s[o] = (i) => t[o](i)) : (t = t.call(e), r = (o) => s[o] = (i) => {
    if (n) {
      if (n = !1, o === "throw") throw i;
      return i;
    }
    return n = !0, {
      done: !1,
      value: new D(new Promise((c) => {
        var d = t[o](i);
        d instanceof Object || Tt("Object expected"), c(d);
      }), 1)
    };
  }), s[$("iterator")] = () => s, r("next"), "throw" in t ? r("throw") : s.throw = (o) => {
    throw o;
  }, "return" in t && r("return"), s;
}, Ce = (e, t, n) => (t = e[$("asyncIterator")]) ? t.call(e) : (e = e[$("iterator")](), t = {}, n = (r, s) => (s = e[r]) && (t[r] = (o) => new Promise((i, c, d) => (o = s.call(e, o), d = o.done, Promise.resolve(o.value).then((l) => i({ value: l, done: d }), c)))), n("next"), n("return"), t);
const qe = {
  development: {
    ASSETS_DRM_API_URL: "http://localhost:5100/assets-drm",
    BUCKET_NAME: "revex-assets-drm-staging",
    IMAGE_STREAM_BASE_URL: "https://staging.assetsdrm.clientclub.net"
  },
  staging: {
    ASSETS_DRM_API_URL: "https://staging.backend.leadconnectorhq.com/assets-drm",
    BUCKET_NAME: "revex-assets-drm-staging",
    IMAGE_STREAM_BASE_URL: "https://staging.assetsdrm.clientclub.net"
  },
  production: {
    ASSETS_DRM_API_URL: "https://backend.leadconnectorhq.com/assets-drm",
    BUCKET_NAME: "revex-assets-drm-production",
    IMAGE_STREAM_BASE_URL: "https://assetsdrm.clientclub.net"
  }
};
let ze = qe.production;
function Z() {
  return ze;
}
function Sr(e) {
  ze = qe[e];
}
function Je(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Ot } = Object.prototype, { getPrototypeOf: Ee } = Object, te = /* @__PURE__ */ ((e) => (t) => {
  const n = Ot.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), N = (e) => (e = e.toLowerCase(), (t) => te(t) === e), ne = (e) => (t) => typeof t === e, { isArray: v } = Array, z = ne("undefined");
function xt(e) {
  return e !== null && !z(e) && e.constructor !== null && !z(e.constructor) && C(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const We = N("ArrayBuffer");
function _t(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && We(e.buffer), t;
}
const Ct = ne("string"), C = ne("function"), Ve = ne("number"), re = (e) => e !== null && typeof e == "object", Nt = (e) => e === !0 || e === !1, K = (e) => {
  if (te(e) !== "object")
    return !1;
  const t = Ee(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Lt = N("Date"), Ut = N("File"), Pt = N("Blob"), kt = N("FileList"), Dt = (e) => re(e) && C(e.pipe), Ft = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || C(e.append) && ((t = te(e)) === "formdata" || // detect form-data instance
  t === "object" && C(e.toString) && e.toString() === "[object FormData]"));
}, Bt = N("URLSearchParams"), [It, $t, vt, Mt] = ["ReadableStream", "Request", "Response", "Headers"].map(N), jt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function J(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), v(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let c;
    for (r = 0; r < i; r++)
      c = o[r], t.call(null, e[c], c, e);
  }
}
function Ke(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const F = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, Ge = (e) => !z(e) && e !== F;
function fe() {
  const { caseless: e } = Ge(this) && this || {}, t = {}, n = (r, s) => {
    const o = e && Ke(t, s) || s;
    K(t[o]) && K(r) ? t[o] = fe(t[o], r) : K(r) ? t[o] = fe({}, r) : v(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && J(arguments[r], n);
  return t;
}
const Ht = (e, t, n, { allOwnKeys: r } = {}) => (J(t, (s, o) => {
  n && C(s) ? e[o] = Je(s, n) : e[o] = s;
}, { allOwnKeys: r }), e), qt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), zt = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Jt = (e, t, n, r) => {
  let s, o, i;
  const c = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      i = s[o], (!r || r(i, e, t)) && !c[i] && (t[i] = e[i], c[i] = !0);
    e = n !== !1 && Ee(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Wt = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Vt = (e) => {
  if (!e) return null;
  if (v(e)) return e;
  let t = e.length;
  if (!Ve(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Kt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && Ee(Uint8Array)), Gt = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, Xt = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Qt = N("HTMLFormElement"), Zt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), Ne = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Yt = N("RegExp"), Xe = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  J(n, (s, o) => {
    let i;
    (i = t(s, o, e)) !== !1 && (r[o] = i || s);
  }), Object.defineProperties(e, r);
}, en = (e) => {
  Xe(e, (t, n) => {
    if (C(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (C(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, tn = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((o) => {
      n[o] = !0;
    });
  };
  return v(e) ? r(e) : r(String(e).split(t)), n;
}, nn = () => {
}, rn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function sn(e) {
  return !!(e && C(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const on = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (re(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const o = v(r) ? [] : {};
        return J(r, (i, c) => {
          const d = n(i, s + 1);
          !z(d) && (o[c] = d);
        }), t[s] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, an = N("AsyncFunction"), cn = (e) => e && (re(e) || C(e)) && C(e.then) && C(e.catch), Qe = ((e, t) => e ? setImmediate : t ? ((n, r) => (F.addEventListener("message", ({ source: s, data: o }) => {
  s === F && o === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), F.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  C(F.postMessage)
), ln = typeof queueMicrotask != "undefined" ? queueMicrotask.bind(F) : typeof process != "undefined" && process.nextTick || Qe, a = {
  isArray: v,
  isArrayBuffer: We,
  isBuffer: xt,
  isFormData: Ft,
  isArrayBufferView: _t,
  isString: Ct,
  isNumber: Ve,
  isBoolean: Nt,
  isObject: re,
  isPlainObject: K,
  isReadableStream: It,
  isRequest: $t,
  isResponse: vt,
  isHeaders: Mt,
  isUndefined: z,
  isDate: Lt,
  isFile: Ut,
  isBlob: Pt,
  isRegExp: Yt,
  isFunction: C,
  isStream: Dt,
  isURLSearchParams: Bt,
  isTypedArray: Kt,
  isFileList: kt,
  forEach: J,
  merge: fe,
  extend: Ht,
  trim: jt,
  stripBOM: qt,
  inherits: zt,
  toFlatObject: Jt,
  kindOf: te,
  kindOfTest: N,
  endsWith: Wt,
  toArray: Vt,
  forEachEntry: Gt,
  matchAll: Xt,
  isHTMLForm: Qt,
  hasOwnProperty: Ne,
  hasOwnProp: Ne,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Xe,
  freezeMethods: en,
  toObjectSet: tn,
  toCamelCase: Zt,
  noop: nn,
  toFiniteNumber: rn,
  findKey: Ke,
  global: F,
  isContextDefined: Ge,
  isSpecCompliantForm: sn,
  toJSONObject: on,
  isAsyncFn: an,
  isThenable: cn,
  setImmediate: Qe,
  asap: ln
};
function m(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
a.inherits(m, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ze = m.prototype, Ye = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Ye[e] = { value: e };
});
Object.defineProperties(m, Ye);
Object.defineProperty(Ze, "isAxiosError", { value: !0 });
m.from = (e, t, n, r, s, o) => {
  const i = Object.create(Ze);
  return a.toFlatObject(e, i, function(d) {
    return d !== Error.prototype;
  }, (c) => c !== "isAxiosError"), m.call(i, e.message, t, n, r, s), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const un = null;
function pe(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function et(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Le(e, t, n) {
  return e ? e.concat(t).map(function(s, o) {
    return s = et(s), !n && o ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function dn(e) {
  return a.isArray(e) && !e.some(pe);
}
const fn = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function se(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, h) {
    return !a.isUndefined(h[y]);
  });
  const r = n.metaTokens, s = n.visitor || u, o = n.dots, i = n.indexes, d = (n.Blob || typeof Blob != "undefined" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(p) {
    if (p === null) return "";
    if (a.isDate(p))
      return p.toISOString();
    if (!d && a.isBlob(p))
      throw new m("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(p) || a.isTypedArray(p) ? d && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function u(p, y, h) {
    let b = p;
    if (p && !h && typeof p == "object") {
      if (a.endsWith(y, "{}"))
        y = r ? y : y.slice(0, -2), p = JSON.stringify(p);
      else if (a.isArray(p) && dn(p) || (a.isFileList(p) || a.endsWith(y, "[]")) && (b = a.toArray(p)))
        return y = et(y), b.forEach(function(A, U) {
          !(a.isUndefined(A) || A === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Le([y], U, o) : i === null ? y : y + "[]",
            l(A)
          );
        }), !1;
    }
    return pe(p) ? !0 : (t.append(Le(h, y, o), l(p)), !1);
  }
  const f = [], w = Object.assign(fn, {
    defaultVisitor: u,
    convertValue: l,
    isVisitable: pe
  });
  function g(p, y) {
    if (!a.isUndefined(p)) {
      if (f.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      f.push(p), a.forEach(p, function(b, R) {
        (!(a.isUndefined(b) || b === null) && s.call(
          t,
          b,
          a.isString(R) ? R.trim() : R,
          y,
          w
        )) === !0 && g(b, y ? y.concat(R) : [R]);
      }), f.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return g(e), t;
}
function Ue(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function be(e, t) {
  this._pairs = [], e && se(e, this, t);
}
const tt = be.prototype;
tt.append = function(t, n) {
  this._pairs.push([t, n]);
};
tt.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Ue);
  } : Ue;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function pn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function nt(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || pn;
  a.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let o;
  if (s ? o = s(t, n) : o = a.isURLSearchParams(t) ? t.toString() : new be(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Pe {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const rt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, hn = typeof URLSearchParams != "undefined" ? URLSearchParams : be, mn = typeof FormData != "undefined" ? FormData : null, yn = typeof Blob != "undefined" ? Blob : null, gn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: hn,
    FormData: mn,
    Blob: yn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Se = typeof window != "undefined" && typeof document != "undefined", he = typeof navigator == "object" && navigator || void 0, wn = Se && (!he || ["ReactNative", "NativeScript", "NS"].indexOf(he.product) < 0), En = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", bn = Se && window.location.href || "http://localhost", Sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({ __proto__: null, hasBrowserEnv: Se, hasStandardBrowserEnv: wn, hasStandardBrowserWebWorkerEnv: En, navigator: he, origin: bn }, Symbol.toStringTag, { value: "Module" })), T = j(j({}, Sn), gn);
function Rn(e, t) {
  return se(e, new T.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, o) {
      return T.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function An(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Tn(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let o;
  for (r = 0; r < s; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function st(e) {
  function t(n, r, s, o) {
    let i = n[o++];
    if (i === "__proto__") return !0;
    const c = Number.isFinite(+i), d = o >= n.length;
    return i = !i && a.isArray(s) ? s.length : i, d ? (a.hasOwnProp(s, i) ? s[i] = [s[i], r] : s[i] = r, !c) : ((!s[i] || !a.isObject(s[i])) && (s[i] = []), t(n, r, s[i], o) && a.isArray(s[i]) && (s[i] = Tn(s[i])), !c);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, s) => {
      t(An(r), s, n, 0);
    }), n;
  }
  return null;
}
function On(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const W = {
  transitional: rt,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, o = a.isObject(t);
    if (o && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return s ? JSON.stringify(st(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t) || a.isReadableStream(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Rn(t, this.formSerializer).toString();
      if ((c = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return se(
          c ? { "files[]": t } : t,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return o || s ? (n.setContentType("application/json", !1), On(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || W.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (a.isResponse(t) || a.isReadableStream(t))
      return t;
    if (t && a.isString(t) && (r && !this.responseType || s)) {
      const i = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (c) {
        if (i)
          throw c.name === "SyntaxError" ? m.from(c, m.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: T.classes.FormData,
    Blob: T.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  W.headers[e] = {};
});
const xn = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), _n = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(i) {
    s = i.indexOf(":"), n = i.substring(0, s).trim().toLowerCase(), r = i.substring(s + 1).trim(), !(!n || t[n] && xn[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, ke = Symbol("internals");
function H(e) {
  return e && String(e).trim().toLowerCase();
}
function G(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(G) : String(e);
}
function Cn(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Nn = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function le(e, t, n, r, s) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function Ln(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Un(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, o, i) {
        return this[r].call(this, t, s, o, i);
      },
      configurable: !0
    });
  });
}
let _ = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function o(c, d, l) {
      const u = H(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = a.findKey(s, u);
      (!f || s[f] === void 0 || l === !0 || l === void 0 && s[f] !== !1) && (s[f || d] = G(c));
    }
    const i = (c, d) => a.forEach(c, (l, u) => o(l, u, d));
    if (a.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (a.isString(t) && (t = t.trim()) && !Nn(t))
      i(_n(t), n);
    else if (a.isHeaders(t))
      for (const [c, d] of t.entries())
        o(d, c, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = H(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return Cn(s);
        if (a.isFunction(n))
          return n.call(this, s, r);
        if (a.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = H(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || le(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function o(i) {
      if (i = H(i), i) {
        const c = a.findKey(r, i);
        c && (!n || le(r, r[c], c, n)) && (delete r[c], s = !0);
      }
    }
    return a.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || le(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (s, o) => {
      const i = a.findKey(r, o);
      if (i) {
        n[i] = G(s), delete n[o];
        return;
      }
      const c = t ? Ln(o) : String(o).trim();
      c !== o && delete n[o], n[c] = G(s), r[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[ke] = this[ke] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(i) {
      const c = H(i);
      r[c] || (Un(s, i), r[c] = !0);
    }
    return a.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
_.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(_.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(_);
function ue(e, t) {
  const n = this || W, r = t || n, s = _.from(r.headers);
  let o = r.data;
  return a.forEach(e, function(c) {
    o = c.call(n, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function ot(e) {
  return !!(e && e.__CANCEL__);
}
function M(e, t, n) {
  m.call(this, e == null ? "canceled" : e, m.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(M, m, {
  __CANCEL__: !0
});
function it(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new m(
    "Request failed with status code " + n.status,
    [m.ERR_BAD_REQUEST, m.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Pn(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function kn(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(d) {
    const l = Date.now(), u = r[o];
    i || (i = l), n[s] = d, r[s] = l;
    let f = o, w = 0;
    for (; f !== s; )
      w += n[f++], f = f % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), l - i < t)
      return;
    const g = u && l - u;
    return g ? Math.round(w * 1e3 / g) : void 0;
  };
}
function Dn(e, t) {
  let n = 0, r = 1e3 / t, s, o;
  const i = (l, u = Date.now()) => {
    n = u, s = null, o && (clearTimeout(o), o = null), e.apply(null, l);
  };
  return [(...l) => {
    const u = Date.now(), f = u - n;
    f >= r ? i(l, u) : (s = l, o || (o = setTimeout(() => {
      o = null, i(s);
    }, r - f)));
  }, () => s && i(s)];
}
const Y = (e, t, n = 3) => {
  let r = 0;
  const s = kn(50, 250);
  return Dn((o) => {
    const i = o.loaded, c = o.lengthComputable ? o.total : void 0, d = i - r, l = s(d), u = i <= c;
    r = i;
    const f = {
      loaded: i,
      total: c,
      progress: c ? i / c : void 0,
      bytes: d,
      rate: l || void 0,
      estimated: l && c && u ? (c - i) / l : void 0,
      event: o,
      lengthComputable: c != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, n);
}, De = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Fe = (e) => (...t) => a.asap(() => e(...t)), Fn = T.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, T.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(T.origin),
  T.navigator && /(msie|trident)/i.test(T.navigator.userAgent)
) : () => !0, Bn = T.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      a.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), a.isString(r) && i.push("path=" + r), a.isString(s) && i.push("domain=" + s), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function In(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function $n(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function at(e, t, n) {
  let r = !In(t);
  return e && r || n == !1 ? $n(e, t) : t;
}
const Be = (e) => e instanceof _ ? j({}, e) : e;
function I(e, t) {
  t = t || {};
  const n = {};
  function r(l, u, f, w) {
    return a.isPlainObject(l) && a.isPlainObject(u) ? a.merge.call({ caseless: w }, l, u) : a.isPlainObject(u) ? a.merge({}, u) : a.isArray(u) ? u.slice() : u;
  }
  function s(l, u, f, w) {
    if (a.isUndefined(u)) {
      if (!a.isUndefined(l))
        return r(void 0, l, f, w);
    } else return r(l, u, f, w);
  }
  function o(l, u) {
    if (!a.isUndefined(u))
      return r(void 0, u);
  }
  function i(l, u) {
    if (a.isUndefined(u)) {
      if (!a.isUndefined(l))
        return r(void 0, l);
    } else return r(void 0, u);
  }
  function c(l, u, f) {
    if (f in t)
      return r(l, u);
    if (f in e)
      return r(void 0, l);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: c,
    headers: (l, u, f) => s(Be(l), Be(u), f, !0)
  };
  return a.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const f = d[u] || s, w = f(e[u], t[u], u);
    a.isUndefined(w) && f !== c || (n[u] = w);
  }), n;
}
const ct = (e) => {
  const t = I({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: o, headers: i, auth: c } = t;
  t.headers = i = _.from(i), t.url = nt(at(t.baseURL, t.url), e.params, e.paramsSerializer), c && i.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  );
  let d;
  if (a.isFormData(n)) {
    if (T.hasStandardBrowserEnv || T.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((d = i.getContentType()) !== !1) {
      const [l, ...u] = d ? d.split(";").map((f) => f.trim()).filter(Boolean) : [];
      i.setContentType([l || "multipart/form-data", ...u].join("; "));
    }
  }
  if (T.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && Fn(t.url))) {
    const l = s && o && Bn.read(o);
    l && i.set(s, l);
  }
  return t;
}, vn = typeof XMLHttpRequest != "undefined", Mn = vn && function(e) {
  return new Promise(function(n, r) {
    const s = ct(e);
    let o = s.data;
    const i = _.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: d, onDownloadProgress: l } = s, u, f, w, g, p;
    function y() {
      g && g(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let h = new XMLHttpRequest();
    h.open(s.method.toUpperCase(), s.url, !0), h.timeout = s.timeout;
    function b() {
      if (!h)
        return;
      const A = _.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), O = {
        data: !c || c === "text" || c === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: A,
        config: e,
        request: h
      };
      it(function(k) {
        n(k), y();
      }, function(k) {
        r(k), y();
      }, O), h = null;
    }
    "onloadend" in h ? h.onloadend = b : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, h.onabort = function() {
      h && (r(new m("Request aborted", m.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function() {
      r(new m("Network Error", m.ERR_NETWORK, e, h)), h = null;
    }, h.ontimeout = function() {
      let U = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const O = s.transitional || rt;
      s.timeoutErrorMessage && (U = s.timeoutErrorMessage), r(new m(
        U,
        O.clarifyTimeoutError ? m.ETIMEDOUT : m.ECONNABORTED,
        e,
        h
      )), h = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in h && a.forEach(i.toJSON(), function(U, O) {
      h.setRequestHeader(O, U);
    }), a.isUndefined(s.withCredentials) || (h.withCredentials = !!s.withCredentials), c && c !== "json" && (h.responseType = s.responseType), l && ([w, p] = Y(l, !0), h.addEventListener("progress", w)), d && h.upload && ([f, g] = Y(d), h.upload.addEventListener("progress", f), h.upload.addEventListener("loadend", g)), (s.cancelToken || s.signal) && (u = (A) => {
      h && (r(!A || A.type ? new M(null, e, h) : A), h.abort(), h = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const R = Pn(s.url);
    if (R && T.protocols.indexOf(R) === -1) {
      r(new m("Unsupported protocol " + R + ":", m.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(o || null);
  });
}, jn = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const o = function(l) {
      if (!s) {
        s = !0, c();
        const u = l instanceof Error ? l : this.reason;
        r.abort(u instanceof m ? u : new M(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, o(new m(`timeout ${t} of ms exceeded`, m.ETIMEDOUT));
    }, t);
    const c = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((l) => {
        l.unsubscribe ? l.unsubscribe(o) : l.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((l) => l.addEventListener("abort", o));
    const { signal: d } = r;
    return d.unsubscribe = () => a.asap(c), d;
  }
}, Hn = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, qn = function(e, t) {
  return ae(this, null, function* () {
    try {
      for (var n = Ce(zn(e)), r, s, o; r = !(s = yield new D(n.next())).done; r = !1) {
        const i = s.value;
        yield* ce(Hn(i, t));
      }
    } catch (s) {
      o = [s];
    } finally {
      try {
        r && (s = n.return) && (yield new D(s.call(n)));
      } finally {
        if (o)
          throw o[0];
      }
    }
  });
}, zn = function(e) {
  return ae(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* ce(e);
      return;
    }
    const t = e.getReader();
    try {
      for (; ; ) {
        const { done: n, value: r } = yield new D(t.read());
        if (n)
          break;
        yield r;
      }
    } finally {
      yield new D(t.cancel());
    }
  });
}, Ie = (e, t, n, r) => {
  const s = qn(e, t);
  let o = 0, i, c = (l) => {
    i || (i = !0, r && r(l));
  };
  return new ReadableStream({
    pull(l) {
      return E(this, null, function* () {
        try {
          const { done: u, value: f } = yield s.next();
          if (u) {
            c(), l.close();
            return;
          }
          let w = f.byteLength;
          if (n) {
            let g = o += w;
            n(g);
          }
          l.enqueue(new Uint8Array(f));
        } catch (u) {
          throw c(u), u;
        }
      });
    },
    cancel(l) {
      return c(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, oe = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", lt = oe && typeof ReadableStream == "function", Jn = oe && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : (e) => E(void 0, null, function* () {
  return new Uint8Array(yield new Response(e).arrayBuffer());
})), ut = (e, ...t) => {
  try {
    return !!e(...t);
  } catch (n) {
    return !1;
  }
}, Wn = lt && ut(() => {
  let e = !1;
  const t = new Request(T.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), $e = 64 * 1024, me = lt && ut(() => a.isReadableStream(new Response("").body)), ee = {
  stream: me && ((e) => e.body)
};
oe && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !ee[t] && (ee[t] = a.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new m(`Response type '${t}' is not supported`, m.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Vn = (e) => E(void 0, null, function* () {
  if (e == null)
    return 0;
  if (a.isBlob(e))
    return e.size;
  if (a.isSpecCompliantForm(e))
    return (yield new Request(T.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (a.isArrayBufferView(e) || a.isArrayBuffer(e))
    return e.byteLength;
  if (a.isURLSearchParams(e) && (e = e + ""), a.isString(e))
    return (yield Jn(e)).byteLength;
}), Kn = (e, t) => E(void 0, null, function* () {
  const n = a.toFiniteNumber(e.getContentLength());
  return n == null ? Vn(t) : n;
}), Gn = oe && ((e) => E(void 0, null, function* () {
  let {
    url: t,
    method: n,
    data: r,
    signal: s,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: c,
    onUploadProgress: d,
    responseType: l,
    headers: u,
    withCredentials: f = "same-origin",
    fetchOptions: w
  } = ct(e);
  l = l ? (l + "").toLowerCase() : "text";
  let g = jn([s, o && o.toAbortSignal()], i), p;
  const y = g && g.unsubscribe && (() => {
    g.unsubscribe();
  });
  let h;
  try {
    if (d && Wn && n !== "get" && n !== "head" && (h = yield Kn(u, r)) !== 0) {
      let O = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), P;
      if (a.isFormData(r) && (P = O.headers.get("content-type")) && u.setContentType(P), O.body) {
        const [k, V] = De(
          h,
          Y(Fe(d))
        );
        r = Ie(O.body, $e, k, V);
      }
    }
    a.isString(f) || (f = f ? "include" : "omit");
    const b = "credentials" in Request.prototype;
    p = new Request(t, _e(j({}, w), {
      signal: g,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: b ? f : void 0
    }));
    let R = yield fetch(p);
    const A = me && (l === "stream" || l === "response");
    if (me && (c || A && y)) {
      const O = {};
      ["status", "statusText", "headers"].forEach((Te) => {
        O[Te] = R[Te];
      });
      const P = a.toFiniteNumber(R.headers.get("content-length")), [k, V] = c && De(
        P,
        Y(Fe(c), !0)
      ) || [];
      R = new Response(
        Ie(R.body, $e, k, () => {
          V && V(), y && y();
        }),
        O
      );
    }
    l = l || "text";
    let U = yield ee[a.findKey(ee, l) || "text"](R, e);
    return !A && y && y(), yield new Promise((O, P) => {
      it(O, P, {
        data: U,
        headers: _.from(R.headers),
        status: R.status,
        statusText: R.statusText,
        config: e,
        request: p
      });
    });
  } catch (b) {
    throw y && y(), b && b.name === "TypeError" && /fetch/i.test(b.message) ? Object.assign(
      new m("Network Error", m.ERR_NETWORK, e, p),
      {
        cause: b.cause || b
      }
    ) : m.from(b, b && b.code, e, p);
  }
})), ye = {
  http: un,
  xhr: Mn,
  fetch: Gn
};
a.forEach(ye, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (n) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ve = (e) => `- ${e}`, Xn = (e) => a.isFunction(e) || e === null || e === !1, dt = {
  getAdapter: (e) => {
    e = a.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !Xn(n) && (r = ye[(i = String(n)).toLowerCase()], r === void 0))
        throw new m(`Unknown adapter '${i}'`);
      if (r)
        break;
      s[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(s).map(
        ([c, d]) => `adapter ${c} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(ve).join(`
`) : " " + ve(o[0]) : "as no adapter specified";
      throw new m(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: ye
};
function de(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new M(null, e);
}
function Me(e) {
  return de(e), e.headers = _.from(e.headers), e.data = ue.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), dt.getAdapter(e.adapter || W.adapter)(e).then(function(r) {
    return de(e), r.data = ue.call(
      e,
      e.transformResponse,
      r
    ), r.headers = _.from(r.headers), r;
  }, function(r) {
    return ot(r) || (de(e), r && r.response && (r.response.data = ue.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = _.from(r.response.headers))), Promise.reject(r);
  });
}
const ft = "1.8.1", ie = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ie[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const je = {};
ie.transitional = function(t, n, r) {
  function s(o, i) {
    return "[Axios v" + ft + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, c) => {
    if (t === !1)
      throw new m(
        s(i, " has been removed" + (n ? " in " + n : "")),
        m.ERR_DEPRECATED
      );
    return n && !je[i] && (je[i] = !0), t ? t(o, i, c) : !0;
  };
};
ie.spelling = function(t) {
  return (n, r) => !0;
};
function Qn(e, t, n) {
  if (typeof e != "object")
    throw new m("options must be an object", m.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const o = r[s], i = t[o];
    if (i) {
      const c = e[o], d = c === void 0 || i(c, o, e);
      if (d !== !0)
        throw new m("option " + o + " must be " + d, m.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new m("Unknown option " + o, m.ERR_BAD_OPTION);
  }
}
const X = {
  assertOptions: Qn,
  validators: ie
}, L = X.validators;
let B = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Pe(),
      response: new Pe()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    return E(this, null, function* () {
      try {
        return yield this._request(t, n);
      } catch (r) {
        if (r instanceof Error) {
          let s = {};
          Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
          const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
          try {
            r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
          } catch (i) {
          }
        }
        throw r;
      }
    });
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = I(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: o } = n;
    r !== void 0 && X.assertOptions(r, {
      silentJSONParsing: L.transitional(L.boolean),
      forcedJSONParsing: L.transitional(L.boolean),
      clarifyTimeoutError: L.transitional(L.boolean)
    }, !1), s != null && (a.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : X.assertOptions(s, {
      encode: L.function,
      serialize: L.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), X.assertOptions(n, {
      baseUrl: L.spelling("baseURL"),
      withXsrfToken: L.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && a.merge(
      o.common,
      o[n.method]
    );
    o && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete o[p];
      }
    ), n.headers = _.concat(i, o);
    const c = [];
    let d = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(n) === !1 || (d = d && y.synchronous, c.unshift(y.fulfilled, y.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(y) {
      l.push(y.fulfilled, y.rejected);
    });
    let u, f = 0, w;
    if (!d) {
      const p = [Me.bind(this), void 0];
      for (p.unshift.apply(p, c), p.push.apply(p, l), w = p.length, u = Promise.resolve(n); f < w; )
        u = u.then(p[f++], p[f++]);
      return u;
    }
    w = c.length;
    let g = n;
    for (f = 0; f < w; ) {
      const p = c[f++], y = c[f++];
      try {
        g = p(g);
      } catch (h) {
        y.call(this, h);
        break;
      }
    }
    try {
      u = Me.call(this, g);
    } catch (p) {
      return Promise.reject(p);
    }
    for (f = 0, w = l.length; f < w; )
      u = u.then(l[f++], l[f++]);
    return u;
  }
  getUri(t) {
    t = I(this.defaults, t);
    const n = at(t.baseURL, t.url, t.allowAbsoluteUrls);
    return nt(n, t.params, t.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(t) {
  B.prototype[t] = function(n, r) {
    return this.request(I(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, i, c) {
      return this.request(I(c || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  B.prototype[t] = n(), B.prototype[t + "Form"] = n(!0);
});
let Zn = class pt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const i = new Promise((c) => {
        r.subscribe(c), o = c;
      }).then(s);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(o, i, c) {
      r.reason || (r.reason = new M(o, i, c), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new pt(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function Yn(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function er(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const ge = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ge).forEach(([e, t]) => {
  ge[t] = e;
});
function ht(e) {
  const t = new B(e), n = Je(B.prototype.request, t);
  return a.extend(n, B.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return ht(I(e, s));
  }, n;
}
const S = ht(W);
S.Axios = B;
S.CanceledError = M;
S.CancelToken = Zn;
S.isCancel = ot;
S.VERSION = ft;
S.toFormData = se;
S.AxiosError = m;
S.Cancel = S.CanceledError;
S.all = function(t) {
  return Promise.all(t);
};
S.spread = Yn;
S.isAxiosError = er;
S.mergeConfig = I;
S.AxiosHeaders = _;
S.formToJSON = (e) => st(a.isHTMLForm(e) ? new FormData(e) : e);
S.getAdapter = dt.getAdapter;
S.HttpStatusCode = ge;
S.default = S;
const {
  Axios: Tr,
  AxiosError: Or,
  CanceledError: xr,
  isCancel: _r,
  CancelToken: Cr,
  VERSION: Nr,
  all: Lr,
  Cancel: Ur,
  isAxiosError: Pr,
  spread: kr,
  toFormData: Dr,
  AxiosHeaders: Fr,
  HttpStatusCode: Br,
  formToJSON: Ir,
  getAdapter: $r,
  mergeConfig: vr
} = S, tr = {
  video: {
    "video/mp4": "mp4",
    "video/webm": "webm",
    "video/ogg": "ogv",
    "video/quicktime": "mov",
    "video/x-matroska": "mkv",
    "video/x-msvideo": "avi",
    "video/x-flv": "flv",
    "video/3gpp": "3gp",
    "video/3gpp2": "3g2"
  },
  audio: {
    "audio/mpeg": "mp3",
    "audio/ogg": "ogg",
    "audio/wav": "wav",
    "audio/webm": "webm",
    "audio/aac": "aac",
    "audio/x-wav": "wav",
    "audio/x-aiff": "aiff",
    "audio/midi": "mid",
    "audio/x-midi": "mid",
    "audio/flac": "flac",
    "audio/x-ms-wma": "wma"
  },
  image: {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",
    "image/tiff": "tiff",
    "image/bmp": "bmp",
    "image/x-icon": "ico"
  }
}, nr = (e) => e.startsWith("video/") ? "video" : e.startsWith("audio/") ? "audio" : e.startsWith("image/") ? "image" : "other", rr = (e) => {
  var o;
  const t = nr(e), n = tr[t];
  if (n && e in n)
    return n[e];
  const r = (o = e.split("/")[1]) == null ? void 0 : o.split(";")[0];
  return r ? r.replace(/^x-/, "").split("+")[0] : {
    video: "mp4",
    audio: "mp3",
    image: "png",
    other: "bin"
  }[t] || "bin";
}, sr = (e, t) => {
  const n = rr(t), r = `asset_${Date.now()}.${n}`;
  return e ? `${e.replace(/\.[^/.]+$/, "")}.${n}` : r;
}, Mr = (e) => E(void 0, null, function* () {
  var t;
  try {
    const { signedUrl: n, name: r } = yield wt.getDownloadSignedUrl(
      e.assetsLicenseId
    );
    if (!n) throw new Error("No signed URL found");
    return e.fileName = e.fileName || r, new Promise((s, o) => {
      const i = new XMLHttpRequest();
      i.open("GET", n, !0), i.responseType = "blob", i.addEventListener("progress", (c) => {
        var l;
        const d = c.total > 0 ? c.loaded / c.total * 100 : 0;
        (l = e.onProgress) == null || l.call(e, d);
      }), i.addEventListener("loadend", () => {
        if (i.status === 200) {
          const c = i.response, d = c.type, l = sr(e.fileName, d), u = document.createElement("a"), f = window.URL.createObjectURL(c);
          u.style.display = "none", u.href = f, u.download = l, document.body.appendChild(u), u.click(), window.URL.revokeObjectURL(f), document.body.removeChild(u), s();
        } else
          o(
            new Error(
              `Failed to download file: ${i.status} ${i.statusText}`
            )
          );
      }), i.addEventListener("error", () => {
        o(new Error("Network error occurred while downloading file"));
      }), i.send();
    });
  } catch (n) {
    (t = e.onError) == null || t.call(e, n);
  }
}), jr = (e) => E(void 0, null, function* () {
  const { assetsLicenseId: t, onSuccess: n, onError: r } = e;
  try {
    yield wt.delete(t), n == null || n();
  } catch (s) {
    r == null || r();
  }
}), or = () => window.location.origin.includes("gokollab.com");
let mt = null;
const Hr = (e) => {
  mt = e;
}, ir = () => mt;
let yt = null;
const qr = (e) => {
  yt = e;
}, Re = () => yt, ar = () => E(void 0, null, function* () {
  if (Re())
    try {
      const t = yield Er.ping();
      return t ? gt(t) : null;
    } catch (t) {
      return null;
    }
  return null;
});
let q = null, we = null;
const Q = (e) => {
  q = e;
}, cr = () => E(void 0, null, function* () {
  if (ir() === "public")
    return null;
  if (we) {
    const n = yield we();
    if (n)
      return Q(n), n;
  }
  if (window != null && window.getToken) {
    const n = yield window.getToken();
    if (n)
      return Q(n), n;
  }
  if (Re()) {
    if (q && !ur(q, 60))
      return q;
    const n = yield ar();
    if (n)
      return Q(n), n;
  }
  return q;
}), zr = (e) => {
  we = e;
}, gt = (e) => {
  var r, s, o, i, c, d, l, u, f, w, g, p;
  const t = ((s = (r = e.config.headers).get) == null ? void 0 : s.call(r, "authorization")) || ((i = (o = e.config.headers).get) == null ? void 0 : i.call(o, "Authorization")) || ((c = e.config.headers) == null ? void 0 : c.authorization) || ((d = e.config.headers) == null ? void 0 : d.Authorization), n = ((u = (l = e.config.headers).get) == null ? void 0 : u.call(l, "token-id")) || ((w = (f = e.config.headers).get) == null ? void 0 : w.call(f, "Token-Id")) || ((g = e.config.headers) == null ? void 0 : g["token-id"]) || ((p = e.config.headers) == null ? void 0 : p["Token-Id"]);
  return t && typeof t == "string" && t.startsWith("Bearer ") ? t.replace("Bearer ", "") : n && typeof n == "string" ? n : null;
}, lr = (e) => {
  try {
    const t = e.split(".");
    if (t.length !== 3)
      return null;
    const n = t[1], r = atob(n.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(r);
  } catch (t) {
    return null;
  }
}, ur = (e, t = 60) => {
  if (!e)
    return !0;
  const n = lr(e);
  if (!n || !n.exp)
    return !0;
  const r = n.exp, s = Math.floor(Date.now() / 1e3);
  return r - s <= t;
};
class Ae {
  get endPoint() {
    return this.endpoint;
  }
}
var dr = /* @__PURE__ */ ((e) => (e.COMPLETED = "completed", e.PROCESSING = "processing", e.REMAINING = "remaining", e.ERROR = "error", e.UNCODABLE = "uncodable", e))(dr || {}), fr = /* @__PURE__ */ ((e) => (e.video = "video", e.audio = "audio", e.pdf = "pdf", e.image = "image", e))(fr || {}), pr = /* @__PURE__ */ ((e) => (e.HOST = "host", e.ATTENDEE = "attendee", e))(pr || {}), hr = /* @__PURE__ */ ((e) => (e.SCHEDULED = "scheduled", e.LIVE = "live", e.DISCONNECTED = "disconnected", e.COMPLETED = "completed", e))(hr || {});
let mr = class extends Ae {
  get endpoint() {
    return "/assets-license";
  }
  getAsset(t) {
    return E(this, null, function* () {
      return fetch(
        `${Z().ASSETS_DRM_API_URL}${this.endpoint}/${t}`
      ).then((n) => n.json());
    });
  }
  getProcessingStatus(t) {
    return E(this, null, function* () {
      return x().get(`${this.endpoint}/${t}/processing-status`).then((n) => n.data);
    });
  }
  delete(t) {
    return E(this, null, function* () {
      return x().delete(`${this.endpoint}/${t}`).then(() => {
      });
    });
  }
  getDownloadSignedUrl(t) {
    return E(this, null, function* () {
      return x().get(`${this.endpoint}/${t}/signed-url/download`).then((n) => n.data);
    });
  }
  logAnalytics(t, n) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}/${t}/analytics`, {
        analytics: n
      }).then(() => {
      });
    });
  }
  generateLiveSessionToken(t, n) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}/${t}/live/token`, n).then((r) => r.data);
    });
  }
  joinLiveSession(t, n) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}/${t}/live/join`, {
        token: n
      }).then((r) => r.data);
    });
  }
  leaveLiveSession(t, n) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}/${t}/live/leave`, {
        token: n
      }).then((r) => r.data);
    });
  }
  getLiveSessionState(t) {
    return E(this, null, function* () {
      return x().get(`${this.endpoint}/${t}/live/state`).then((n) => n.data);
    });
  }
}, yr = class extends Ae {
  get endpoint() {
    return "/assets";
  }
  getUploadSignedUrl(c) {
    return E(this, arguments, function* ({
      source: t,
      entityId: n,
      type: r,
      mimeType: s,
      assetId: o,
      bucketType: i
    }) {
      return x().post(`${this.endpoint}/signed-url/upload`, {
        source: t,
        entityId: n,
        type: r,
        mimeType: s,
        assetId: o,
        bucketType: i
      }).then((d) => d.data);
    });
  }
  createAsset(t) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}`, t).then((n) => n.data);
    });
  }
  ping() {
    return E(this, null, function* () {
      return x().get(`${this.endpoint}/ping`).then((t) => t);
    });
  }
  getProxyAsset(t, n, r) {
    return E(this, null, function* () {
      return fetch(
        `${Z().ASSETS_DRM_API_URL}${this.endpoint}/proxy/${t}/${n}/${r}`
      ).then((s) => s.json());
    });
  }
};
var gr = /* @__PURE__ */ ((e) => (e.MUTE_MIC = "mute_mic", e.TURN_OFF_VIDEO = "turn_off_video", e.ALLOW_AUDIO = "allow_audio", e.DISABLE_AUDIO = "disable_audio", e.ALLOW_VIDEO = "allow_video", e.DISABLE_VIDEO = "disable_video", e.ALLOW_SCREEN_SHARE = "allow_screen_share", e.DISABLE_SCREEN_SHARE = "disable_screen_share", e.KICK = "kick", e))(gr || {});
let wr = class extends Ae {
  get endpoint() {
    return "/live-sessions";
  }
  addChat(t, n) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}/${t}/chats`, n).then((r) => r.data);
    });
  }
  getChats(t, n) {
    return E(this, null, function* () {
      return x().get(`${this.endpoint}/${t}/chats`, { params: n }).then((r) => r.data);
    });
  }
  moderateParticipants(t, n, r) {
    return E(this, null, function* () {
      return x().post(`${this.endpoint}/${t}/moderate`, r, {
        params: { hostToken: n }
      }).then((s) => s.data);
    });
  }
};
const He = () => ({
  channel: "APP",
  source: or() ? "PORTAL_USER" : "WEB_USER",
  version: "2021-07-28"
}), x = (e) => {
  const t = Re();
  if (t)
    return t.defaults.baseURL = Z().ASSETS_DRM_API_URL, t.defaults.headers.common = He(), t.interceptors.response.use((s) => {
      try {
        const o = gt(s);
        o && Q(o);
      } catch (o) {
      }
      return s;
    }), t;
  const n = Z().ASSETS_DRM_API_URL, r = S.create({
    baseURL: n,
    headers: He()
  });
  return r.interceptors.request.use(
    (s) => E(void 0, null, function* () {
      try {
        const o = yield cr();
        if (!o)
          throw new Error("Token not found");
        s.headers["token-id"] = o, e != null && e.skipAuth || (s.headers.authorization = `Bearer ${o}`);
      } catch (o) {
      }
      return s;
    })
  ), r;
}, Er = new yr(), wt = new mr(), Kr = new wr();
export {
  wt as A,
  hr as L,
  gr as M,
  dr as P,
  Q as a,
  Er as b,
  fr as c,
  Mr as d,
  jr as e,
  Hr as f,
  Z as g,
  ir as h,
  cr as i,
  pr as j,
  Kr as k,
  wr as l,
  zr as m,
  qr as n,
  Sr as s
};
